const routes = [
    {
        path: "/room/bed/availability",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: 'housingbuilding_bedstatusatdate',
        }
    }
];

export default routes;
